import { type RawTestimonialData, type StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import { Richtext } from 'storyblok-js-client';

export type TestimonialType = {
    component: 'testimonial';
    id: string;
    sbEditable?: StoryblokEditable;
    text: Richtext;
};

type TransformTestimonialProps = {
    testimonial: RawTestimonialData | RawTestimonialData[] | undefined;
};

const transformTestimonial = ({ testimonial }: TransformTestimonialProps): TestimonialType | undefined => {
    if (!testimonial || (Array.isArray(testimonial) && !testimonial?.[0])) {
        return;
    }

    const testimonialData = Array.isArray(testimonial) ? testimonial[0] : testimonial;
    const { _uid, _editable, component, richText } = testimonialData;

    return {
        component,
        id: _uid,
        sbEditable: transformPreviewEditable(_editable),
        text: richText,
    };
};

export default transformTestimonial;
